import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsm3m } from "../../../../data/projects/M3M/data";

export const M3MGolfHills = () => {
  const {
    m3mgolfhills: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsm3m;

  return (
    <>
      <Helmet>
        <title>M3M Golf Hills, Sector 79, Gurgaon – Luxury Golf-Themed Residences</title>
        <meta
          name="description"
          content="Discover luxury living at M3M Golf Hills, Sector 79, Gurgaon – a premium golf-course-themed residential project featuring spacious apartments, world-class amenities, and lush green landscapes."
        />

        <meta
          name="keywords"
          content="M3M Golf Hills, M3M Golf Hills Gurgaon, M3M Golf Hills Sector 79, golf residences Gurgaon, luxury apartments in Gurgaon, M3M real estate, premium homes in Gurgaon, golf course apartments"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/m3m-golf-hills-sector-79-gurugram"
        />

        <meta
          name="robots"
          content="index, follow"
        />
      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
